module.exports = __webpack_public_path__ + "static/media/Blender-5.b30f3b4c.webp";